import { useState } from 'react';
import withLogo from '@/assets/with_logo.svg';
import { ErrorBoundary } from '@/components/ErrorBoundary/ErrorBoundary';
import cs from './ReactPlayground.module.scss';

interface Props {
  name: string;
}

function Counter() {
  const [count, setCount] = useState(0);

  return (
    <button type="button" className={cs.button} onClick={() => setCount((count) => count + 1)}>
      count is {count}
    </button>
  );
}

function ErrorTrigger() {
  const [shouldThrow, setShouldThrow] = useState(false);

  if (shouldThrow) {
    throw new Error('テスト用のエラーです');
  }

  return (
    <button type="button" className={cs.errorButton} onClick={() => setShouldThrow(true)}>
      エラーを発生させる
    </button>
  );
}

export default function ReactPlayground({ name }: Props) {
  return (
    <ErrorBoundary>
      <div className={cs.root}>
        <div className={cs.container}>
          <a href="/mypages/setting" className={cs.backButton}>
            ← 設定に戻る
          </a>

          <img src={withLogo} alt="" className={cs.logo} />

          <div className={cs.greeting}>Hello {name}!</div>

          <Counter />

          <ErrorTrigger />
        </div>
      </div>
    </ErrorBoundary>
  );
}
